export enum MccMatchEnum {
    IN = 'IN',
    NOT_IN = 'NOT IN',
}
